import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AgenteFinanceiroResolver } from "src/app/shared/resolvers/agente-financeiro.resolver";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";

import { CanDeactivateGuardService } from "src/app/core/can-deactivate-guard.service";
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { NovaSubscricaoCotaComponent } from "./subscricao-cotas/nova-subscricao-cota/nova-subscricao-cota.component";
import { EdicaoSubscricaoCotaComponent } from "./subscricao-cotas/edicao-subscricao-cota/edicao-subscricao-cota.component";
import { ConglomeradoPesquisaComponent } from "./conglomerado/pesquisa/conglomerado-pesquisa.component";
import { NovoConglomeradoComponent } from "./conglomerado/novo-conglomerado/novo-conglomerado.component";
import { NovoPatrimonioLiquidoComponent } from "./patrimonio-liquido/novo-patrimonio-liquido/novo-patrimonio-liquido.component"
import { PatrimonioLiquidoPesquisaComponent } from "./patrimonio-liquido/pesquisa/patrimonio-liquido-pesquisa.component";
import { SubscricaoCotasPesquisaComponent } from "./subscricao-cotas/subscricao-cotas-pesquisa/subscricao-cotas-pesquisa.component";
import { NovaHabilitacaoAlternativaComponent } from "./habilitacao-alternativa/nova-habilitacao-alternativa/nova-habilitacao-alternativa.component";
import { HabilitacaoAlternativaPesquisaComponent } from "./habilitacao-alternativa/pesquisa-habilitacao-alternativa/habilitacao-alternativa-pesquisa.component";

const routes: Routes = [
    {
        path: 'habilitacao/subscricao',
        canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
        component: SubscricaoCotasPesquisaComponent,
        resolve: {
            agentes: AgenteFinanceiroResolver,
        },
    },
    {
      path: 'habilitacao/subscricao/novo',
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
      component: NovaSubscricaoCotaComponent,
      canDeactivate: [CanDeactivateGuardService],
    },
    {
      path: 'habilitacao/subscricao-cota/detalhes/:id/:tipo',
      component: EdicaoSubscricaoCotaComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
      data: { canReuse: false }
    },
    {
      path: 'habilitacao/conglomerado',
      component: ConglomeradoPesquisaComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    },
    {
      path: 'habilitacao/conglomerado/novo',
      component: NovoConglomeradoComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
      resolve: {
        agentes: AgenteFinanceiroResolver,
      },
    },
    {
      path: 'habilitacao/conglomerado/:id',
      component: NovoConglomeradoComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
      resolve: {
        agentes: AgenteFinanceiroResolver,
      },
    },
    {
      path: 'habilitacao/patrimonio-liquido',
      component: PatrimonioLiquidoPesquisaComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    },
    {
      path: 'habilitacao/patrimonio-liquido/novo',
      component: NovoPatrimonioLiquidoComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    },
    {
      path: 'habilitacao/patrimonio-liquido/:id',
      component: NovoPatrimonioLiquidoComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    },
    {
      path: 'habilitacao/alternativa/novo',
      component: NovaHabilitacaoAlternativaComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    },
    {
      path: 'habilitacao/alternativa',
      component: HabilitacaoAlternativaPesquisaComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    },
    {
      path: 'habilitacao/alternativa/:id',
      component: NovaHabilitacaoAlternativaComponent,
      canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    },
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class HabilitacaoRoutingModule{}
